import React, { Suspense } from 'react';
import { Box } from '@gluestack-ui/themed';

import { SPARKLINE_HEIGHT_PX } from './sparklineSeries';
import type { SparklineChartProps } from './SparklineChart';

const SparklineChart = React.lazy(() => import('./SparklineChart'));

export type SparklineProps = SparklineChartProps;

/**
 * Lazy-loaded sparkline (Recharts in a separate chunk).
 */
export function Sparkline({ testID, ...chartProps }: SparklineProps) {
  return (
    <Suspense
      fallback={(
        <Box height={SPARKLINE_HEIGHT_PX} width="100%" testID={`${testID ?? 'sparkline'}-loading`} />
      )}
    >
      <SparklineChart testID={testID} {...chartProps} />
    </Suspense>
  );
}
